import type { TMessages } from '@/types/TMessages'

export const messages = {
  registry: 'Реестр ЦБ РФ',
} as const satisfies TMessages
